import * as React from 'react'
import type { SVGProps } from 'react'
function SvgKultureinrichtungenMuseen221982627188(
  props: SVGProps<SVGSVGElement>,
) {
  return (
    <svg
      viewBox="0 0 215 211.2"
      x="0px"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      xmlSpace="preserve"
      y="0px"
      {...props}
    >
      <g>
        <path d="M211.9,205.1H3c-1.7,0-3,1.4-3,3.1c0,1.7,1.4,3,3,3h208.9c1.7,0,3.1-1.4,3.1-3C215,206.5,213.6,205.1,211.9,205.1z" />
        <path d="M21.7,189.5c0,1.7,1.4,3,3,3h165.5c1.7,0,3-1.4,3-3s-1.4-3-3-3H24.8C23.1,186.4,21.7,187.8,21.7,189.5z" />
        <path d="M120.2,174.5c1.7,0,3-1.4,3-3V72.1c0-1.7-1.4-3-3-3H94.8c-1.7,0-3,1.4-3,3v99.4c0,1.7,1.4,3,3,3H120.2z M97.8,168.4V75.2 h19.3v93.2H97.8z" />
        <path d="M66.4,174.5c1.7,0,3-1.4,3-3V72.1c0-1.7-1.4-3-3-3H41c-1.7,0-3,1.4-3,3v99.4c0,1.7,1.4,3,3,3H66.4z M44,168.4V75.2h19.3 v93.2H44z" />
        <path d="M174,174.5c1.7,0,3-1.4,3-3V72.1c0-1.7-1.4-3-3-3h-25.4c-1.7,0-3,1.4-3,3v99.4c0,1.7,1.4,3,3,3H174z M171,75.2v93.2h-19.3 V75.2H171z" />
        <path d="M96.6,41.8h21.8c1.7,0,3-1.4,3-3s-1.4-3-3-3H96.6c-1.7,0-3.1,1.4-3.1,3S94.9,41.8,96.6,41.8z" />
        <path d="M11.6,57.1h187.8c5.8,0,10.5-4.7,10.5-10.5c0-4.4-2.8-8.3-6.9-9.8L106.6,0.2c-0.7-0.3-1.5-0.3-2.2,0L8.1,36.8 c-4.1,1.5-6.9,5.5-6.9,9.9C1.2,52.4,5.9,57.1,11.6,57.1z M7.3,46.7c0-1.8,1.2-3.5,2.9-4.1l95.3-36.2l95.4,36.2 c1.7,0.6,2.9,2.3,2.9,4.1c0,2.4-2,4.4-4.4,4.4H11.6C9.2,51,7.3,49.1,7.3,46.7z" />
      </g>
    </svg>
  )
}
export default SvgKultureinrichtungenMuseen221982627188
